// extracted by mini-css-extract-plugin
export var description = "UpsellCTA_description__JQinH";
export var title = "UpsellCTA_title__sC3iG";
export var upsellBox = "UpsellCTA_upsellBox__yHDpx";